import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../../constants';
const styles = () => ({
  container: {
    padding: '4rem',
  },
  heading: {
    textAlign: 'center',
    fontSize: '2rem',
    paddingTop: '2rem',
  },
  name: {
    margin: 'auto',
    fontSize: '2rem',
    textAlign: 'center',
  },
  nameContainter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
  },
  cross: {
    border: '1px solid black',
    padding: '3px 6px',
    borderRadius: '50%',
    cursor: 'pointer',
  },
  searchBox: {
    marginBottom: '2rem',
  },
  tableContainer: {
    backgroundColor: COLORS.WHITE,
    margin: '2rem',
    padding: '1rem',
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: COLORS.GREEN,
    },
  },
  radioContainer: {
    margin: '10px 0',
  },
  inputDiv: {
    marginRight: 'auto',
    marginLeft: 'auto',
    marginBottom: '20px',
    paddingBottom: '20px',
    borderRadius: '5px',
    backgroundColor: COLORS.GREY,
  },
  imageContainer: {
    backgroundColor: '#F1F1F1',
    padding: '10px',
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 15px',
    marginTop: 10,
  },
  acceptButton: {
    backgroundColor: COLORS.GREEN,
    color: 'white',
    borderRadius: 0,
  },
  rejectButton: {
    borderRadius: 0,
    color: '#707070',
  },
  innercontainer: {
    position: 'relative',
    '& img': {
      width: '100%',
      minHeight: '200px',
      objectFit: 'cover',
    },
  },
  checkIcon: {
    position: 'absolute',
    right: 10,
    top: 10,
    cursor: 'pointer',
  },
  radioGroup: {
    width: '100%',
    justifyContent: 'space-between',
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
    },
  },
  paginationContainer: {
    margin: '25px auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .button': {
      marginLeft: 15,
    },
  },
  pagination: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .button': {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    '& svg': {
      margin: '0 15px',
    },
  },
  previous: {
    '& svg': {
      // display: 'flex',
      transform: 'rotate(180deg)',
    },
  },
  disabled: {
    color: 'lightgrey',
    cursor: 'initial !important',
    '& svg': {
      fill: 'lightgrey',
    },
  },
});

export const useStyles = makeStyles(theme => ({
  root: {
    border: 0,
    color:
      theme.palette.type === 'light'
        ? 'rgba(0,0,0,.85)'
        : 'rgba(255,255,255,0.85)',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    WebkitFontSmoothing: 'auto',
    letterSpacing: 'normal',
    '& .Mui-disabled': {
      color: `${COLORS.GREY_LIGHT} !important`,
    },
  },
}));
export default styles;
